import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Busyable } from 'src/app/shared/editors/busyable';
import { ApiService } from 'src/app/Services/api.service';

@Component({
    selector: 'app-reliantconfig',
    templateUrl: './reliantconfig.component.html',
    styleUrls: ['./reliantconfig.component.scss'],
    standalone: false
})
export class ReliantConfigComponent extends Busyable implements OnInit {
  public ModelId: any;
  public Model: any;

  constructor(private apiService: ApiService, private parentRoute: ActivatedRoute) {
    super();
  }

  ngOnInit(): void {
    this.Loading();
    this.parentRoute.params.subscribe(params => { this.ModelId = params['id']; });
    this.apiService.Get<any>("integrations/reliant/configuration/" + this.ModelId).then(result => {
      this.Model = result;
      this.StopLoading();
    });
  }
}
